import { USERS_EDIT } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  user: {},
  fetchUserStatus: undefined,
  fetchUserError: undefined,
  editUserStatus: undefined,
  editUserError: undefined,
  resendInvitationStatus: undefined,
  resendInvitationError: undefined,
  resetPasswordStatus: undefined,
  resetPasswordError: undefined,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USERS_EDIT.UNSET:
      return {
        ...state,
        [action.payload]: undefined,
      };
    case USERS_EDIT.FETCH_USER:
      return {
        ...state,
        fetchUserStatus: CONSTANTS.API.STARTED,
      };
    case USERS_EDIT.FETCH_USER_SUCCEEDED:
      return {
        ...state,
        user: action.payload,
        fetchUserStatus: CONSTANTS.API.SUCCEEDED,
      };
    case USERS_EDIT.FETCH_USER_FAILED:
      return {
        ...state,
        fetchUserError: action.payload,
        fetchUserStatus: CONSTANTS.API.FAILED,
      };
    case USERS_EDIT.EDIT_USER:
      return {
        ...state,
        editUserStatus: CONSTANTS.API.STARTED,
      };
    case USERS_EDIT.EDIT_USER_SUCCEEDED:
      return {
        ...state,
        editUserStatus: CONSTANTS.API.SUCCEEDED,
      };
    case USERS_EDIT.EDIT_USER_FAILED:
      return {
        ...state,
        editUserError: action.payload,
        editUserStatus: CONSTANTS.API.FAILED,
      };
    case USERS_EDIT.RESEND_INVITATION:
      return {
        ...state,
        resendInvitationStatus: CONSTANTS.API.STARTED,
      };
    case USERS_EDIT.RESEND_INVITATION_SUCCEEDED:
      return {
        ...state,
        resendInvitationStatus: CONSTANTS.API.SUCCEEDED,
      };
    case USERS_EDIT.RESEND_INVITATION_FAILED:
      return {
        ...state,
        resendInvitationStatus: CONSTANTS.API.FAILED,
        resendInvitationError: action.payload,
      };
    case USERS_EDIT.RESET_PASSWORD:
      return {
        ...state,
        resetPasswordStatus: CONSTANTS.API.STARTED,
      };
    case USERS_EDIT.RESET_PASSWORD_SUCCEEDED:
      return {
        ...state,
        resetPasswordStatus: CONSTANTS.API.SUCCEEDED,
      };
    case USERS_EDIT.RESET_PASSWORD_FAILED:
      return {
        ...state,
        resetPasswordStatus: CONSTANTS.API.FAILED,
        resetPasswordError: action.payload,
      };
    default:
      return state;
  }
};
